import React from 'react';
import {description} from './../description_more'
import {more} from './../assets/rooms_img'
import SecondHead from './../components/SecondHead'

const MoreMonte = (props) => {
    return (
    	<>
        <SecondHead lang = {props.lang} link = {props.link}/>
        

		<div className="container">

			<div className="row mt-4">
				<div className="col-md-5 "><img src={more.tara} className="img-fluid picture-more px-3 py-3" alt = "tara"/></div>
				<div className="col-md-7 pt-5 fs-3 bg3">{description('tara',props.lang)}</div>
			</div>
			<div className="row mt-4">
				<div className="col-md-7 fs-3 bg3">{description('scadar',props.lang)}</div>
				<div className="col-md-5"><img src={more.scadar} className="img-fluid picture-more px-3 py-3" alt = "scadar"/></div>
			</div>
			<div className="row mt-4">
				<div className="col-md-5"><img src={more.kotor} className="img-fluid picture-more px-3 py-3" alt = "kotor"/></div>
				<div className="col-md-7 fs-3 bg3">{description('kotor',props.lang)}</div>
			</div>
			<div className="row mt-4">
				<div className="col-md-7 fs-3 bg3">{description('petrovich','en')}</div>
				<div className="col-md-5"><img src={more.petrovich} className="img-fluid picture-more px-3 py-3" alt="petrovich"/></div>
			</div>
			<div className="row mt-4 mb-5">
				<div className="col-md-5"><img src={more.plaza} className="img-fluid picture-more px-3 py-3" alt="plaza"/></div>
				<div className="col-md-7 fs-3 bg3">{description('plaza',props.lang)}</div>
			</div>

		</div>
		</>
    );
};


export default MoreMonte;
